import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';

import '@maersk-global/mds-components-core/mc-modal';
import '@maersk-global/mds-components-core/mc-button';
import '@maersk-global/mds-components-core/mc-checkbox';

@Component({
  selector: 'app-print-dialog',
  standalone: true,
  imports: [],
  templateUrl: './print-dialog.component.html',
  styleUrl: './print-dialog.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PrintDialogComponent {
  @Input() open = false;
  @Output() closed = new EventEmitter<void>();
  @Output() printConfirmed = new EventEmitter<boolean>();

  includeRemarks = true;

  onRemarksChange(event: Event): void {
    this.includeRemarks = (event as CustomEvent).target
      ? (event.target as HTMLInputElement).checked
      : ((event as CustomEvent).detail?.checked ?? this.includeRemarks);
  }

  onCancel(): void {
    this.closed.emit();
  }

  onPrint(): void {
    this.printConfirmed.emit(this.includeRemarks);
  }
}
